import { useEffect, useState } from "react";
import { Drawer } from "../../../../../components/drawers/Drawer";
import { closeInvoicesJob, getUser, openInvoicesJobView, useHub } from "../../../../../core/Global";
import Job from "../../models/Job";
import JobInvoice from "../../models/JobInvoice";
import { API_ROUTES } from "../../../../../core/Constants";
import Icon from "../../../../../components/base/Icon";
import { toastError } from "../../../../../components/base/Toast";
import Indicator from "../../../../../components/base/Indicator";
import FlexRow from "../../../../../components/base/FlexRow";
import { BottomSheet } from "../../../../../components/base/BottomSheet";



interface IProps {
    job: Job
}
export default function MobileJobInvoicesList(props: IProps) {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });

    const hub = useHub()
    const user = getUser()

    const [creatingEstimate, creatingEstimateSet] = useState<boolean>(false)
    const [creatingInvoice, creatingInvoiceSet] = useState<boolean>(false)
    const [sheetOpen, sheetOpenSet] = useState<boolean>(false)
    const [model, modelSet] = useState<JobInvoice[]>([])

    const busy = creatingEstimate || creatingInvoice

    const fetch = () => {
        hub.Get(`${API_ROUTES.JobInvoices}all/${props.job.id}`, res => modelSet(res.data))
    }
    useEffect(() => {
        fetch()
    }, [])

    const createEstimate = () => {
        if (busy) return
        creatingEstimateSet(true)
        sheetOpenSet(false)
        hub.Post(API_ROUTES.JobInvoices + "estimate", {
            jobId: props.job.id,
            techId: props.job.techId
        }, res => {
            if (res.success && res.data) openInvoicesJobView(res.data, fetch)
            else toastError(res.message)
            creatingEstimateSet(false)
        })
    }

    const createInvoice = () => {
        if (busy) return
        creatingInvoiceSet(true)
        sheetOpenSet(false)
        hub.Post(API_ROUTES.JobInvoices + "invoice", {
            jobId: props.job.id,
            techId: props.job.techId
        }, res => {
            if (res.success && res.data) openInvoicesJobView(res.data, fetch)
            else toastError(res.message)
            creatingInvoiceSet(false)
        })
    }

    const ToolbarAdd = () => (
        <button
            onClick={() => sheetOpenSet(true)}
            disabled={busy}
            title="Create new"
            style={{
                width: 36,
                height: 36,
                borderRadius: 999,
                background: busy ? "var(--bs-primary-border-subtle)" : "var(--bs-primary)",
                color: "#fff",
                border: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)"
            }}
        >
            {
                busy
                    ? <Icon icon="spinner-third" type="solid" size={14} />
                    : <Icon icon="plus" type="regular" size={16} />
            }
        </button>
    )

    return (
        <Drawer id="drawer-mobile-job-invoices"
            title="Estimates/Invoices"
            toolbarComponent={ToolbarAdd}
            onClose={closeInvoicesJob}
        >

            <div style={{ position: "relative", minHeight: "calc(100vh - 120px)" }}>

                {
                    model.length === 0 && !busy &&
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        padding: "80px 24px 24px",
                        color: "var(--bs-tertiary-color)"
                    }}>
                        <div style={{
                            width: 64,
                            height: 64,
                            borderRadius: 999,
                            background: "var(--bs-secondary-bg)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 14
                        }}>
                            <Icon icon="file-invoice-dollar" type="thin" size={26} />
                        </div>
                        <div style={{ fontSize: 15, fontWeight: 500, color: "var(--bs-secondary-color)" }}>
                            No estimates or invoices yet
                        </div>
                        <div style={{ fontSize: 13, marginTop: 4 }}>
                            Tap the + button to create one
                        </div>
                    </div>
                }

                {
                    busy && model.length === 0 &&
                    <div style={{ padding: "40px 16px", textAlign: "center" }}>
                        <Indicator text={creatingEstimate ? "Creating Estimate..." : "Creating Invoice..."} />
                    </div>
                }

                {
                    model.map(inv =>
                        <FlexRow key={inv.id}
                            className="py-4"
                            style={{
                                borderBottom: "1px solid var(--bs-border-color)",
                                cursor: "pointer"
                            }}
                            onClick={() => openInvoicesJobView(inv, fetch)}>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <FlexRow style={{ gap: 8, flexWrap: "wrap" }}>
                                    <span style={{
                                        fontSize: 11,
                                        fontWeight: 600,
                                        letterSpacing: 0.4,
                                        textTransform: "uppercase",
                                        color: inv.issued ? "var(--bs-primary)" : "var(--bs-secondary-color)"
                                    }}>
                                        {inv.issued ? "Invoice" : "Estimate"}
                                    </span>
                                    <span style={{ fontSize: 13, color: "var(--bs-tertiary-color)" }}>
                                        {/* number already comes through with a leading "#" */}
                                        {inv.number}
                                    </span>
                                    {
                                        inv.acceptLog &&
                                        <span className="badge badge-light-success" style={{ fontSize: 10 }}>
                                            <Icon icon="check-circle" type="solid" className="me-1" />
                                            Accepted
                                        </span>
                                    }
                                    {
                                        inv.signatureLog &&
                                        <span className="badge badge-light-primary" style={{ fontSize: 10 }}>
                                            <Icon icon="signature" type="solid" className="me-1" />
                                            Signed
                                        </span>
                                    }
                                </FlexRow>
                                <div style={{ fontSize: 17, fontWeight: 600, color: "var(--bs-body-color)", marginTop: 4 }}>
                                    {moneyFormatter.format(inv.total ?? 0)}
                                </div>
                            </div>
                            <div style={{ marginLeft: 12, color: "var(--bs-border-color)" }}>
                                <Icon icon="chevron-right" size={16} />
                            </div>
                        </FlexRow>
                    )
                }

            </div>

            <BottomSheet id="sheet-create-invoice-estimate"
                open={sheetOpen}
                onClose={() => sheetOpenSet(false)}>
                <div style={{ padding: "4px 4px 8px" }}>
                    <div style={{
                        fontSize: 12,
                        fontWeight: 600,
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                        color: "var(--bs-tertiary-color)",
                        padding: "8px 12px 12px"
                    }}>
                        Create new
                    </div>

                    <button onClick={createEstimate}
                        disabled={busy}
                        style={sheetItemStyle}>
                        <div style={{ ...sheetIconWrap, background: "var(--bs-primary-bg-subtle)", color: "var(--bs-primary)" }}>
                            <Icon icon="file-lines" type="regular" size={18} />
                        </div>
                        <div style={{ flex: 1, textAlign: "left" }}>
                            <div style={{ fontSize: 15, fontWeight: 600, color: "var(--bs-body-color)" }}>
                                Estimate
                            </div>
                            <div style={{ fontSize: 12, color: "var(--bs-secondary-color)", marginTop: 2 }}>
                                Quote for the customer to review
                            </div>
                        </div>
                        <Icon icon="chevron-right" size={14} />
                    </button>

                    <button onClick={createInvoice}
                        disabled={busy}
                        style={sheetItemStyle}>
                        <div style={{ ...sheetIconWrap, background: "var(--bs-success-bg-subtle)", color: "var(--bs-success)" }}>
                            <Icon icon="file-invoice-dollar" type="regular" size={18} />
                        </div>
                        <div style={{ flex: 1, textAlign: "left" }}>
                            <div style={{ fontSize: 15, fontWeight: 600, color: "var(--bs-body-color)" }}>
                                Invoice
                            </div>
                            <div style={{ fontSize: 12, color: "var(--bs-secondary-color)", marginTop: 2 }}>
                                Bill the customer for completed work
                            </div>
                        </div>
                        <Icon icon="chevron-right" size={14} />
                    </button>
                </div>
            </BottomSheet>

        </Drawer>
    )
}

const sheetItemStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 14,
    width: "100%",
    padding: "14px 12px",
    background: "transparent",
    border: "none",
    borderRadius: 12,
    cursor: "pointer",
    color: "var(--bs-tertiary-color)"
}

const sheetIconWrap: React.CSSProperties = {
    width: 40,
    height: 40,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
}
